<script>
export default {
  props: {
    pickerType: {
      type: String,
      default: '',
      require: false,
    },
    label: {
      type: String,
      default: 'common.registered_date',
      require: false,
    },
  },
  data() {
    return {
      date: {},
    }
  },
  methods: {
    handleClose(show) {
      this.$emit('export', this.date)
      show()
    },
    fromToDate(val) {
      this.date = val
    },
  },
}
</script>

<template>
  <BaseDropDown
    text-button="common.export"
    class="ml-1"
    add-menu-classes="csv-export-popup"
  >
    <template v-slot="{ show }">
      <validation-observer ref="observer" v-slot="{ handleSubmit }">
        <CForm
          class="d-flex flex-column px-2 pt-2 export-popup-form-wrapper"
          @submit.stop.prevent="handleSubmit(() => handleClose(show))"
        >
          <slot>
            <label class="py-1 mb-0">{{ $t(label) }}</label>
          </slot>

          <BaseDateRangerPickerCsv
            :picker-type="pickerType"
            :start-date="date.date_start"
            :end-date="date.date_end"
            :rules="{
              required: true,
            }"
            @update:value="fromToDate"
          />
          <CButton
            class="py-0 align-self-end"
            color="dark"
            variant="outline"
            type="submit"
            >{{ $t('common.export') }}</CButton
          >
        </CForm>
      </validation-observer>
    </template>
  </BaseDropDown>
</template>

<style lang="scss" scoped>
.export-popup-form-wrapper {
  width: 400px;
}
</style>
